var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoExclamationWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18503 9.87645L6.98139 2.90918H8.97412L8.75594 9.87645H7.18503ZM8.01412 13.1928C7.66503 13.1928 7.37897 13.0862 7.15594 12.8728C6.9426 12.6595 6.83594 12.4025 6.83594 12.1019C6.83594 11.7916 6.9426 11.5298 7.15594 11.3165C7.37897 11.1031 7.66503 10.9965 8.01412 10.9965C8.34382 10.9965 8.61533 11.1031 8.82866 11.3165C9.0517 11.5298 9.16321 11.7916 9.16321 12.1019C9.16321 12.4025 9.0517 12.6595 8.82866 12.8728C8.61533 13.0862 8.34382 13.1928 8.01412 13.1928Z",
    fill: "#0073E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoExclamationWhite);
export default __webpack_public_path__ + "static/media/picto_exclamation_white.113e265a2ffc1c38131edaeb590d4e71.svg";
export { ForwardRef as ReactComponent };